/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */
import { defineMessages } from 'react-intl';

export default defineMessages({
  DefaultOption: {
    id: 'Form.Select.DefaultOption',
    defaultMessage: 'Select One'
  }
});
